import { memo, useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BzModal, BzModalHeader, BzModalBody, BzButton, BzInputText, BzModalFooter, BzLoader } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { saveCartForGoback, saveCartInfo, saveCartSuccess, updateOrderCartAction, getOrderCartAction, storeGridData, convertToOrderCart, updateOrderCartRowData } from '../../redux/actions/orderCart';
import { toastConfig } from '../../redux/actions/toast';
import { isGuestUser } from '../../utils/global_functions';
import { useLocation } from 'react-router';
import { ORDER_PRODUCT_TYPES, ORDER_TYPES } from '../../utils/global_variables';
const OrderCartModal = () => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const modalData = useSelector(state => state?.modals?.modalData);
    const [orderCartName, setOrderCartName] = useState("");
    //If remove variable state function not working
    // eslint-disable-next-line no-unused-vars
    const [strNewOrderCartId, setStrNewOrderCartId] = useState("");
    const bIsOrderEntryApiPending = useSelector(state => state?.orders?.bIsOrderEntryApiPending); // BT-106965 : ManasaB : 23-07-2024 : Duplicates cart creating issue
    const handleClose = () => {
        setOrderCartName('');//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 10-04-2024
        dispatch(storeGridData([]));
        dispatch(saveCartForGoback({}));
        dispatch(saveCartSuccess(false));
        dispatch(convertToOrderCart(false));
        dispatch(updateOrderCartRowData({}));
        dispatch(handleModal([{ 'ORDER_CART_NAME_MODAL': false }, true]));
    };
    const onHandleChange = (e) => {
        setOrderCartName((e.target.value).toUpperCase()); //BT-106965 : ManasaB : 27/03/2024 : Order Cart : SAT1 issues

    };
    const strIdentifyOrderCartMethod = modalData?.data?.method ? modalData?.data?.method : '';
    const strOrdercartName = modalData?.data?.ordercartName;
    const strOrderCartId = modalData?.data?.strOrderCartId;
    let arrCartData = modalData?.data?.orderCartInfo;
    const arrCartNames = useSelector(state => state?.orderCart?.arrOrderCart);
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    const location = useLocation();
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 -Start
    useEffect(() => {
        if (strOrdercartName) {
            //&& location?.pathname !== '/watchlist' removed from above if bez cart name not displaying in go back -- convert to order cart case ManasaB : 08-05-2024
            setOrderCartName(strOrdercartName);
        }
    }, [strOrdercartName, modalData, location]);
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - End
    const checkCartNameExists = () => {

        const objExistCartData = arrCartNames.find(eachCartName => eachCartName.ordercartName === orderCartName);
        if (objExistCartData && !modalData?.data?.isGoback) { //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024
            return true;
        }
        else {
            return false;
        }
    };
    useEffect(() => {
        if (strIdentifyOrderCartMethod === "edit") {
            setOrderCartName(strOrdercartName);
        }
        if (!isGuestUser()) {
            dispatch(getOrderCartAction());
        } else { }
    }, [strOrdercartName, strIdentifyOrderCartMethod, dispatch]);
    //BT-106965 : ManasaB : 27/03/2024 : Order Cart : SAT1 issues - Start
    const handleKeyDown = (event) => {
        if (!/^[a-zA-Z0-9]*$/.test(event.key)) {
            event.preventDefault();
        }
    };
    //BT-106965 : ManasaB : 27/03/2024 : Order Cart : SAT1 issues - End
    const handleConfirmModal = () => {
        let nPriceSL = '';
        let arrOrders = arrCartData?.map(eachData => {
            // let arrOrders = arrCartOrderData?.map(eachData => {
            //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To send sl limit values when order type is SL - Start
            if (eachData.orderType === 'SL') {
                nPriceSL = eachData.slLimit;
            }
            //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 : To send sl limit values when order type is SL - End
            let objOrder = {
                LTP: eachData.price,
                PercNetChange: 0.00,
                OpenPrice: 0.00,
                HighPrice: 0.00,
                LowPrice: 0.00,
                ClosePrice: 0.00,
                NetChangeInRs: 0.00,
                LUT: "",
                LTPTrend: "",
                arrowTrend: "",
                PercNetChangeRaw: "",
                BuyPrice: 0.00,
                BuyQty: 0.00,
                SellPrice: 0.00,
                SellQty: 0.00,
                Volume: 0.00,
                LTPChangeCss: "",
                scripDetail:
                {
                    symbol: eachData.symbol,
                    _Series: eachData.series,
                    _InstrumentName: eachData.instrument,
                    _ExchangeName: eachData.exchange,
                    _ExpiryDate: eachData.expiryDate,
                    _OptionType: eachData.optionType,
                    _StrikePrice: eachData.strikePrice,
                    MarketLot: eachData.marketLot, // BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024
                    PriceTick: eachData.priceTick, // BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024
                    SecurityDesc: eachData.securityDesc,
                    MWSecurityDesc: `${eachData.symbol}    ${eachData.series}`,
                    DecimalLocator: eachData.decimalLocator,
                    PriceFormat: "",
                    ISIN: eachData.isinCode,
                    SPOS: "",
                    POS: "",
                    OrderType: "",
                    Quantity: 0,
                    Price: 0,
                    ProductType: "",
                    AssetToken: 0,
                    Spread: 0,
                    FIILimit: 0,
                    NRILimit: 949,
                    FOExists: 1,
                    MarginTypeIndicator: 1,
                    priceNumerator: 1,
                    priceDenominator: 1,
                    genNumerator: 1,
                    genDenominator: 1,
                    intrinsicValue: 1,
                    displaySymbol: eachData.symbol,
                    displaySeries: eachData.series,
                    displayExchange: eachData.exchange,
                    displayInstrument: eachData.instrument,
                    displayExpiryDate: "",
                    displayStrikePrice: "",
                    displayOptionType: "",
                    exchangeColorCss: "nse",
                    isIndex: false,
                    spotIndex: 0,
                    BidAskPrice: 0.00,
                    BidAskQuantity: 0,
                    BestFive: [],
                    LTP: eachData.price,
                    NetChangeInRs: 0.00,
                    PercNetChange: 0.00,
                    LTPTrend: "",
                    totalBuyQty: 0,
                    totalSellQty: 0,
                    totalBidQtyPer: "-",
                    totalAskQtyPer: "-",
                    sQtyUnit: "",
                    sSurvMeasureDescription: eachData?.sSurvMeasureDescription,
                    nSequenceNo: "",
                    maturityDate: eachData.maturityDate,
                    expiryInMilliSec: eachData.expiryInMilliSec,
                    scripDet:
                    {
                        isIndex: false,
                        sIndexDesc: "",
                        isGlobal: 0,
                        token: eachData.token,
                        _MktSegId: eachData.mappedSegId,
                        _MapMktSegId: eachData.mappedSegId // need to do
                    }
                },
                requestBody: {
                    quantity: eachData.count,
                    transaction_type: eachData.buySellType,
                    product_type: eachData.productType === ORDER_PRODUCT_TYPES.MARGIN ? ORDER_PRODUCT_TYPES.INTRADAY : (eachData.productType === ORDER_PRODUCT_TYPES.CARRYFORWARD ? ORDER_PRODUCT_TYPES.DELIVERY : eachData.productType), //ManasaB : 04-11-2025 : Product Type Issue
                    order_type: eachData.orderType,
                    disclosed_quantity: eachData.disc,
                    is_amo: eachData.amo,
                    price: nPriceSL ? nPriceSL : eachData.price,
                    order_identifier: "",
                    scrip_info: {
                        exchange: eachData.exchangeSegment,
                        expiry_date: eachData?.expiryDate,
                        option_type: eachData?.optionType,
                        scrip_token: eachData.token,
                        series: eachData.series,
                        strike_price: eachData?.strikePrice,
                        symbol: eachData.symbol
                    },
                    trigger_price: eachData.slTrigger,
                    validity: eachData.validity,
                    validity_days: 0,
                    displayProductType: eachData.productType
                },
                selected: false,
                BGChangeCSS: "nochange-bg"
            };
            return objOrder;
        });
        let objPayload = {};
        if (strIdentifyOrderCartMethod === "edit" || modalData?.data?.isGoback) { //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024
            objPayload = {
                ordercartId: strOrderCartId,
                ordercartName: orderCartName,
                version: 1,
                createdBy: objLoginSession.data.user_id,
                modifiedBy: objLoginSession.data.user_id,
                executedNoTime: 0,
                orders: JSON.stringify(arrOrders)
            };
        } else {
            objPayload = {
                ordercartName: orderCartName,
                version: 1,
                createdBy: objLoginSession.data.user_id,
                modifiedBy: objLoginSession.data.user_id,
                executedNoTime: 0,
                orders: JSON.stringify(arrOrders)
            };
        }
        const bIsCartNameExists = checkCartNameExists();
        if (bIsCartNameExists && strIdentifyOrderCartMethod !== 'edit') { //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 To show toaster message for duplicate names
            dispatch(toastConfig({ autoDismiss: false, show: true, message: 'Looks like this cart name already exists. Try using a different name.', button: [{ btnName: "Close", type: "Close_Toast_MultiScrip_OrderCart", className: "btn btn-outline-active ms-3", bIsDisabled: false ,onClickHandler : () => dispatch(toastConfig({ show: false })) }] }));
        }
        else {
            //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - Start
            if (strIdentifyOrderCartMethod === "edit" || modalData?.data?.isGoback) {
                dispatch(updateOrderCartAction(objPayload, `${orderCartName} updated successfully`)).then((resp) => {
                    if (resp?.status === 'success') {
                        dispatch(getOrderCartAction()); //Manasa : 19/03/2024 : Order cart flow changes after discussion with Samadhan
                        dispatch(saveCartForGoback({ cartName: orderCartName, cartId: strOrderCartId }));
                        dispatch(saveCartSuccess(true));
                    }
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: `${orderCartName} updated successfully` }));
                    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - End
                    dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': true }, { 'ORDER_CART_NAME_MODAL': false }, true]));
                    dispatch(handleModalData({ data: { orderCartConfirmation: modalData, orderCartName: orderCartName, orderCartId: strOrderCartId, orderEntryTab: 'multi_scrip', activeTabKey: 'basket' } })); //Manasa : 19/03/2024  : order cart id not coming so changed
                    setOrderCartName('');
                });
            } else {

                dispatch(saveCartInfo(objPayload)).then((resp) => {
                    if (resp?.status === 'success') {
                        setStrNewOrderCartId(resp.data[0].ordercartId);
                        dispatch(saveCartSuccess(true));
                        dispatch(saveCartForGoback({ cartName: orderCartName, cartId: resp.data[0].ordercartId }));//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 :
                        dispatch(getOrderCartAction());
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `${orderCartName} saved successfully` }));
                        dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': true }, { 'ORDER_CART_NAME_MODAL': false }, true]));
                        dispatch(handleModalData({ data: { orderCartConfirmation: modalData, orderCartName: orderCartName, orderCartId: resp.data[0].ordercartId, orderEntryTab: 'multi_scrip', activeTabKey: 'basket' } }));
                        setOrderCartName('');
                    }
                });

            }

        }
    };

    //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - End
    const handleSaveCartBack = () => {
        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }, { 'ORDER_CART_NAME_MODAL': false }], true));
        if (modalData?.data?.isGoback) {
            dispatch(handleModalData({ data: { isSaveCartGoBack: true, orderEntryTab: ORDER_TYPES.MULTI_SCRIP, isGoback: true, method: 'edit' } }));
        }
        else {
            dispatch(handleModalData({ data: { isSaveCartGoBack: true, orderEntryTab: ORDER_TYPES.MULTI_SCRIP } }));
        }
    };
    return (
        <>
            <BzModal data-testid="ordercart-savecart-modal" size='sm' show={modals['ORDER_CART_NAME_MODAL']} onHide={handleClose}>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-items-center'>
                                <div data-testid="ordercart-savecart-modal-back-arrow" className='icon-12 icon-backward-arrow icon-primary me-2' onClick={handleSaveCartBack}></div>
                                {strIdentifyOrderCartMethod === "edit" || modalData?.data?.isGoback ?
                                    <div data-test="ordercart-editcart-modal-title" className='font-medium font-size4 color-text'>Order Cart</div>
                                    :
                                    <div data-testid="ordercart-savecart-modal-title" className='font-medium font-size4 color-text'>Name Your Order Cart</div>
                                }
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-items-center'>
                                <div data-testid="ordercart-savecart-modal-close-icon" className='icon-16 icon-dark icon-close' onClick={handleClose}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody className='g-0 min-h_150'>
                    <Container fluid className='p-0'>
                        {/* BT-106965 : ManasaB : 23-07-2024 : Duplicates cart creating issue - Start */}
                        {bIsOrderEntryApiPending ?
                            <div className='order-entry-spinner-overlay h-100 w-100 d-flex justify-content-center align-item-center'>
                                <Row className='g-0 py-3'>
                                    <Col>
                                        <BzLoader spinner={bIsOrderEntryApiPending} spinnerContent="Saving Cart" bIsFfromModal={true} />
                                    </Col>
                                </Row>
                            </div> : null}
                        {/* BT-106965 : ManasaB : 23-07-2024 : Duplicates cart creating issue - End */}
                        <Row className='g-0 mb-2'>
                            {/* BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - Start */}
                            <Col className='d-flex justify-content-start'>
                                {strIdentifyOrderCartMethod === "edit" || modalData?.data?.isGoback ?
                                    <div data-testid="ordercart-editcart-modal-body-label" className='font-regular font-size3 color-text'>Updated Order Cart: {orderCartName}</div>
                                    :
                                    <div data-testid="ordercart-savecart-modal-body-label" className='font-regular font-size3 color-text'>Save Order Cart as: {orderCartName}</div>
                                }
                            </Col>
                            {/* BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - End  */}
                        </Row>
                        {/* BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 -Start  */}
                        {strIdentifyOrderCartMethod === "edit" || modalData?.data?.isGoback ? null :
                            <Row className='g-0 mb-3'>
                                <Col className='d-flex justify-content-start'>
                                    <div className='input-group'>
                                        <BzInputText data-testid="ordercart-savecart-modal-input" size='sm' className='font-regular form-control' value={orderCartName} placeholder='Enter new name here' name="ordercart" onChange={onHandleChange} maxLength={10} minLength={1} onKeyDown={handleKeyDown} />
                                    </div>
                                </Col>
                            </Row>
                        }
                        {/* BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 -End  */}
                    </Container>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-end'>
                                {strIdentifyOrderCartMethod === "edit" || modalData?.data?.isGoback ?
                                    //BT-106965 : ManasaB : 23-07-2024 : Duplicates cart creating issue - Start
                                    <BzButton data-testid="ordercart-editcart-continue-button" className='btn btn-md btn-primary' onClick={handleConfirmModal} disabled={bIsOrderEntryApiPending}> CONTINUE</BzButton> :
                                    <BzButton data-testid="ordercart-savecart-savecontinue-button" className='btn btn-md btn-primary' onClick={handleConfirmModal} disabled={orderCartName?.length === 0 || bIsOrderEntryApiPending}>SAVE &amp; CONTINUE</BzButton>
                                    //BT-106965 : ManasaB : 23-07-2024 : Duplicates cart creating issue - End
                                }
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>

        </>
    );
};

export default memo(OrderCartModal);
